import { REVIEWS_SLIDER_IMAGES_TYPE } from "@apps/reviews/constants";
import {
    Infer,
    boolean,
    instance,
    literal,
    nullable,
    number,
    object,
    optional,
    union,
} from "superstruct";

import { REVIEWS_SLIDER_REVIEWS_SEQUENCE } from "./constants";

export const ReviewsSliderWidgetConfigSchema = object({
    target: instance(HTMLElement),
    lowestRating: number(),
    imagesType: union([
        literal(REVIEWS_SLIDER_IMAGES_TYPE.PRODUCT),
        literal(REVIEWS_SLIDER_IMAGES_TYPE.REVIEWS),
    ]),
    onlyPinnedReviews: boolean(),
    reviewsSequence: union([
        literal(REVIEWS_SLIDER_REVIEWS_SEQUENCE.DEFAULT),
        literal(REVIEWS_SLIDER_REVIEWS_SEQUENCE.SHUFFLE),
    ]),
    productId: optional(number()),
    isWidgetShadowRootEnabled: nullable(boolean()),
});

export const ReviewsSliderWidgetConfigToken = Symbol(
    "ReviewsSliderWidgetConfigToken"
);

export type ReviewsSliderWidgetConfigInterface = Infer<
    typeof ReviewsSliderWidgetConfigSchema
>;
